module.exports = __webpack_public_path__ + "img/badge-list-thumb-088.267ea480.png";